import { jsx } from "panel";
import { SkeletonListRowSize } from "common/components/skeleton-list/types";
import { SkeletonListEl } from "common/components/skeleton-list";
import { TagEl } from "common/components/tag";
import { TagSize } from "common/components/tag/types";
import { ButtonEl } from "common/components/button";
import { DropMenuEl } from "common/components/drop-menu";
import { PositioningStrategy } from "common/components/drop-menu/types";
import { ItemsMenuEl } from "common/components/items-menu";
import { TagInputEl } from "common/components/tag-input";
import { TagInputTheme } from "common/components/tag-input/types";
import { SlackAuthProblem } from "./types";
const containerSelector = `.mp-slack-channel-selector-container`;
function DropDownMenu({ cmp }) {
  const menuWidthStyle = cmp.attr(`menu-width`) === 0 ? {} : { width: `${cmp.attr(`menu-width`)}px` };
  return /* @__PURE__ */ jsx(DropMenuEl, {
    attrs: {
      elRef: `selectDropMenu`,
      open: cmp.state.showingChannelList,
      "position-strategy": PositioningStrategy.Absolute
    },
    style: menuWidthStyle,
    props: { positionParent: cmp }
  }, cmp.state.loadingChannels ? /* @__PURE__ */ jsx(SkeletonListEl, {
    attrs: {
      "num-rows": 4,
      "row-size": SkeletonListRowSize.Large,
      "style-override": `.mp-skeleton-wrapper{padding: 8px;}`
    },
    sel: ".mp-slack-channel-selector-skeleton-list"
  }) : /* @__PURE__ */ jsx(ItemsMenuEl, {
    sel: ".mp-slack-channel-selector-channel-list",
    attrs: {
      multiple: true,
      sections: [{ items: cmp.getSlackChannelsForItemsMenu() }],
      "search-filter": cmp.state.inputText,
      tabindex: `0`
    },
    props: {
      keydownProxyEl: cmp.elmRefs.tagInput
    },
    on: {
      clickItem: cmp.onChannelListItemClick
    }
  }));
}
function RenderSlackAuthProblem({ cmp }) {
  const { slackAuthProblem, selectedChannels } = cmp.state;
  const hasChannels = !!selectedChannels.size;
  const message = slackAuthProblem === SlackAuthProblem.MissingSlackAuthScopesException ? `Reauthorize Slack App` : `Add Mixpanel to Slack`;
  return /* @__PURE__ */ jsx("div", {
    sel: containerSelector
  }, hasChannels && /* @__PURE__ */ jsx("div", {
    sel: ".mp-slack-channel-selector-no-auth-channels"
  }, /* @__PURE__ */ jsx(ChannelsAsTags, {
    cmp,
    isReadonly: true
  })), /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      icon: `slack-logo`,
      href: `/slack/oauth?slack_v2=true&use_internal_landing=true`,
      target: `_blank`
    },
    on: {
      click: cmp.handleReauthorizeClick
    }
  }, message));
}
function RenderReadonly({ cmp }) {
  return /* @__PURE__ */ jsx("div", {
    sel: containerSelector
  }, /* @__PURE__ */ jsx(ChannelsAsTags, {
    cmp,
    isReadonly: true
  }));
}
function ChannelsAsTags({ cmp, isReadonly }) {
  const channelArray = [...cmp.state.selectedChannels];
  return /* @__PURE__ */ jsx(null, null, channelArray.map(([channelId, channel]) => {
    return /* @__PURE__ */ jsx(TagEl, {
      attrs: {
        removable: !isReadonly,
        clickable: false,
        size: TagSize.Small,
        "tag-name": channel.name
      },
      key: `channel-${channelId}`,
      on: { remove: () => cmp.deselectChannel(channel) }
    });
  }));
}
export function template() {
  if (this.attr(`is-readonly`)) {
    return /* @__PURE__ */ jsx(RenderReadonly, {
      cmp: this
    });
  }
  if (this.state.slackAuthProblem) {
    return /* @__PURE__ */ jsx(RenderSlackAuthProblem, {
      cmp: this
    });
  }
  const hasNoChannels = !this.state.selectedChannels.size;
  return /* @__PURE__ */ jsx("div", {
    sel: containerSelector
  }, /* @__PURE__ */ jsx(TagInputEl, {
    attrs: {
      id: `picker`,
      tags: this.picker.getChannelsAsTags(),
      elref: `sharingTagInput`,
      placeholder: hasNoChannels ? `Select a channel` : ``,
      "min-tags": 0,
      "disable-input": this.attr(`is-readonly`),
      "style-override": require(`./tag-input.inline.styl`),
      theme: TagInputTheme.Light,
      "mp-button-attrs": {
        icon: `caret-down`,
        "style-override": require(`./dropdown-button.inline.styl`)
      }
    },
    on: {
      change: this.picker.handleTagInputChange,
      focus: this.picker.handleTagInputFocus,
      buttonPressed: this.onSearchInputButtonPress
    },
    hook: {
      insert: this.picker.handleMpTagInputInsert
    }
  }), /* @__PURE__ */ jsx(DropDownMenu, {
    cmp: this
  }));
}
